export enum BusinessSettingConfigKey {
  CREATOR_HUB_HOMEPAGE_CATEGORIES_V2 = 'CREATOR_HUB_HOMEPAGE_CATEGORIES_V2',
  PUBLIC_SOURCING_MP_CATEGORY_PAGES = 'PUBLIC_SOURCING_MP_CATEGORY_PAGES',
  CREATOR_REVIEWS = 'CREATOR_REVIEWS',
  SUPPLIER_REVIEWS = 'SUPPLIER_REVIEWS',
  DEFAULT_LOGISTICS_FEE_RATE_LADDER = 'DEFAULT_LOGISTICS_FEE_RATE_LADDER',
  SOURCING_LP_POPULAR_TAGS = 'SOURCING_LP_POPULAR_TAGS',
  SOURCING_LP_PACKAGING_PRODUCTS = 'SOURCING_LP_PACKAGINGPRODUCTS',
  SOURCING_LP_FREELANCER_SERVICES = 'SOURCING_LP_FREELANCERSERVICES',
  SOURCING_LP_SOURCE_PRODUCTS = 'SOURCING_LP_SOURCEPRODUCTS',
  SOURCING_LP_PACKAGINGCOMPARISON_PRICE = 'SOURCING_LP_PACKAGINGCOMPARISON_PRICE',
  SOURCING_LP_PACKAGINGCOMPARISON_PERCENTOFF = 'SOURCING_LP_PACKAGINGCOMPARISON_PERCENTOFF',
  SOURCING_AICOLORCHANGER_PICS = 'SOURCING_AICOLORCHANGER_PICS',
  SOURCING_AIFABRICPATTERNCHANGER_PICS = 'SOURCING_AIFABRICPATTERNCHANGER_PICS',
  SOURCING_AICLOTHINGMODELTRYON_PICS = 'SOURCING_AICLOTHINGMODELTRYON_PICS',
  PROMOTED_SUPPLIERS_PREMIUM = 'PROMOTED_SUPPLIERS_PREMIUM',
  PROMOTED_SUPPLIERS_STANDARD = 'PROMOTED_SUPPLIERS_STANDARD',
  SOURCING_CAPABILITIES_SHOWCASE = 'SOURCING_CAPABILITIES_SHOWCASE',
  PROMOTED_SUPPLIERS_AD_PRODUCTS = 'PROMOTED_SUPPLIERS_AD_PRODUCTS',
}

export interface PublicSourcingMarketplaceCategoryPage {
  pageTitle: string;
  metadataTitle: string;
  metadataDescription: string;
  metadataImage: string;
}
